import { SupportedLanguage } from './pricingTranslations';

export type NavLabelKey =
  | 'overview'
  | 'mockStudio'
  | 'smartChat'
  | 'zapTalk'
  | 'examMode'
  | 'myExams'
  | 'scoreboard'
  | 'pricing'
  | 'profile'
  | 'settings';

interface DashboardTranslation {
  navLabels: Record<NavLabelKey, string>;
  logout: string;
  language: string;
  upgradeButton: string;
  brandName: string;
  workspaceLabel: string;
  sidebarAriaLabel: string;
  logoutConfirmation: {
    title: string;
    message: string;
    cancel: string;
    confirm: string;
  };
}

export const dashboardTranslations: Record<SupportedLanguage, DashboardTranslation> = {
  en: {
    navLabels: {
      overview: 'Overview',
      mockStudio: 'Mock Studio',
      smartChat: 'Smart Chat',
      zapTalk: 'ZapTalk',
      examMode: 'Exam Mode',
      myExams: 'My Exams',
      scoreboard: 'Scoreboard',
      pricing: 'Pricing',
      profile: 'Profile',
      settings: 'Settings',
    },
    logout: 'Log out',
    language: 'Language',
    upgradeButton: 'Upgrade',
    brandName: 'ZapTick AI',
    workspaceLabel: 'Student workspace',
    sidebarAriaLabel: 'Sidebar navigation',
    logoutConfirmation: {
      title: 'Confirm Logout',
      message: 'Are you sure you want to log out?',
      cancel: 'Cancel',
      confirm: 'Logout',
    },
  },
  zh: {
    navLabels: {
      overview: '概览',
      mockStudio: '模拟工作室',
      smartChat: '智能聊天',
      zapTalk: 'ZapTalk',
      examMode: '考试模式',
      myExams: '我的考试',
      scoreboard: '成绩板',
      pricing: '定价',
      profile: '个人资料',
      settings: '设置',
    },
    logout: '退出登录',
    language: '语言',
    upgradeButton: '升级',
    brandName: 'Zaptick AI',
    workspaceLabel: '学生工作区',
    sidebarAriaLabel: '侧边导航',
    logoutConfirmation: {
      title: '确认退出',
      message: '您确定要退出吗？',
      cancel: '取消',
      confirm: '退出',
    },
  },
  ko: {
    navLabels: {
      overview: '개요',
      mockStudio: '모의 스튜디오',
      smartChat: '스마트 챗',
      zapTalk: 'ZapTalk',
      examMode: '시험 모드',
      myExams: '내 시험',
      scoreboard: '점수판',
      pricing: '요금제',
      profile: '프로필',
      settings: '설정',
    },
    logout: '로그아웃',
    language: '언어',
    upgradeButton: '업그레이드',
    brandName: 'Zaptick AI',
    workspaceLabel: '학생 작업 공간',
    sidebarAriaLabel: '사이드바 내비게이션',
    logoutConfirmation: {
      title: '로그아웃 확인',
      message: '로그아웃 하시겠습니까?',
      cancel: '취소',
      confirm: '로그아웃',
    },
  },
  ar: {
    navLabels: {
      overview: 'نظرة عامة',
      mockStudio: 'استوديو المحاكاة',
      smartChat: 'دردشة ذكية',
      zapTalk: 'ZapTalk',
      examMode: 'وضع الاختبار',
      myExams: 'اختباراتي',
      scoreboard: 'لوحة النتائج',
      pricing: 'الأسعار',
      profile: 'الملف الشخصي',
      settings: 'الإعدادات',
    },
    logout: 'تسجيل الخروج',
    language: 'اللغة',
    upgradeButton: 'ترقية',
    brandName: 'Zaptick AI',
    workspaceLabel: 'مساحة عمل الطالب',
    sidebarAriaLabel: 'التنقل الجانبي',
    logoutConfirmation: {
      title: 'تأكيد تسجيل الخروج',
      message: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
      cancel: 'إلغاء',
      confirm: 'تسجيل الخروج',
    },
  },
};
